module.exports = __webpack_public_path__ + "img/1.4b0c8aa0.png";